// app/shared/components/toast/toast.component.ts
import { Component, ViewEncapsulation } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-toast',
    imports: [ToastModule],
    template: `<p-toast position="top-right"></p-toast>`,
    styleUrl: './toast.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class ToastComponent {
}
